/**
 * @description E.g. mailing, billing, etc.
 */
export enum AddressType {
  Mailing = 'Mailing',
  Billing = 'Billing',
}



// WEBPACK FOOTER //
// ./src/model/types/address-type.ts